import classnames from 'classnames'

export default function OptionButton({ selected, name, onSelect, children, isDisabled, ...rest }) {
  return (
    <button
      {...rest}
      className={classnames('optionBtn flatBtn', rest.className)}
      onClick={() => onSelect(name)}
      disabled={isDisabled}
    >
      {children}

      <style jsx>{`
        .optionBtn {
          width: 100%;
          height: 4.2rem;
          color: var(--primary-text-color);
          border-radius: 2.1rem;
          font-size: 1.4rem;
          font-weight: 700;
        }

        @media (max-width: 1024px) {
          .optionBtn {
            height: 3.6rem;
            font-size: 1.2rem;
          }
        }
      `}</style>

      <style jsx>{`
        .optionBtn {
          background: ${selected ? 'var(--primary-button-bg)' : '#E9ECF2'};
          color: ${selected ? '#fff' : 'var(--primary-bg-color)'};
        }
      `}</style>
    </button>
  )
}
